import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core';

import DialogHeader from 'components/DialogHeader';

const defaultError = `Não conseguimos reconectar o canal. Verifique se o dispositivo está pronto para se conectar e tente novamente`;

type ModalCodeErrorProps = {
  open: boolean;
  onClose: () => void;
  error: string | undefined;
};

export default function ModalCodeError(props: ModalCodeErrorProps) {
  const { open, onClose, error = defaultError } = props;

  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        handleClose();
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogHeader
        title="Não foi possível conectar o canal"
        onClose={handleClose}
      />

      <DialogContent>
        <DialogContentText>{error}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
